import React, { FunctionComponent } from 'react'
import styles from './SwitchSort.module.sass'
import clsx from 'clsx'
import { Classes } from '../../../styles'

interface Props {
    title: string,
    className?: string,
    data: any,// eslint-disable-line
    value: any,// eslint-disable-line
    text1?: string,
    text2?: string,
    disabled?: boolean,
    onChange: (value: any) => void,// eslint-disable-line
    reversed?: boolean,
}

const SwitchSort: FunctionComponent<Props> = props => {

    return <div>
        <div className={styles.title}>{props.title}</div>
        <div
            className={clsx(props.className, styles.switch, Classes.touchTarget, {
                [styles.reversed]: props.reversed,
                [styles.disabled]: props.disabled,
                [styles.active]: props.value === 'by_priority' ? true : false,
            })}
            onClick={() => !props.disabled && props.onChange(!props.value)}

        >
            {
                props.text1 && <div className={clsx(styles.text, {
                    [styles.active]: props.value === 'by_priority' ? false : true
                })}>{props.text1}</div>
            }
            <div className={styles.element}/>
            {
                props.text2 && <div className={clsx(styles.text, {
                    [styles.active]: props.value === 'by_priority' ? true : false
                })}>{props.text2}</div>
            }
        </div>
    </div>
}

export default SwitchSort